import { type ResourceProps } from '@refinedev/core';

export type ResourceWithPermissions = ResourceProps & {
  permissions: string[];
};

export const resources: ResourceWithPermissions[] = [
  {
    name: 'profile',
    list: '/profile',
    show: '/profile',
    create: '/profile',
    edit: '/profile',
    permissions: ['super.admin', 'user', 'owner'],
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'cp-users',
    list: '/user-management',
    show: '/user-management/show/:id',
    create: '/user-management/create',
    edit: '/user-management/edit/:id',
    permissions: ['super.admin', 'owner'],
    meta: {
      dataProviderName: 'auth',
      canDelete: true,
    },
  },
  {
    name: 'cp-roles',
    list: '/roles',
    show: '/roles/show/:id',
    permissions: ['super.admin', 'user', 'owner'],
    meta: {
      dataProviderName: 'auth',
      canDelete: true,
    },
  },
  {
    name: 'branches',
    list: '/branches',
    show: '/branches/show/:id',
    create: '/branches/create',
    edit: '/branches/edit/:id',
    permissions: [
      'super.admin',
      'user',
      'owner',
      'cp_branch.create',
      'cp_branch.update',
      'cp_branch.delete',
      'cp_branch.list',
      'cp_branch.show',
    ],
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'contacts',
    list: '/contacts',
    show: '/contacts/show/:id',
    create: '/contacts/create',
    edit: '/contacts/edit/:id',
    permissions: [
      'super.admin',
      'user',
      'owner',
      'cp_contact.create',
      'cp_contact.update',
      'cp_contact.delete',
      'cp_contact.list',
      'cp_contact.show',
    ],
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'orders',
    list: '/orders',
    show: '/orders/show/:id',
    create: '/orders/create',
    permissions: [
      'super.admin',
      'user',
      'owner',
      'cp_order.create',
      'cp_order.list',
      'cp_order.show',
    ],
    meta: {
      canDelete: true,
    },
  },
  {
    name: 'invoices',
    list: '/invoices',
    show: '/invoices/show/:id',
    permissions: [
      'super.admin',
      'user',
      'owner',
      'cp_invoice.create',
      'cp_invoice.update',
      'cp_invoice.delete',
      'cp_invoice.list',
      'cp_invoice.show',
    ],
    meta: {
      canDelete: true,
    },
  },
];
